import { HStack, Heading, StackProps } from "@chakra-ui/react";
import React from "react";
import { ImageWithMissingSrc } from "../../../atoms/ImageWithMissingSrc";

/**
 * The data source and image for display in the header.
 */
export function DataSourceTitle({
  name = "Data Source",
  image,
}: {
  name?: string;
  image?: string;
} & StackProps): React.ReactElement {
  return (
    <HStack spacing={4}>
      <ImageWithMissingSrc src={image} noPaddingIcon alt="" boxSize="2.5rem" />
      <Heading as="h2" size="md" fontWeight="semibold">
        {name}
      </Heading>
    </HStack>
  );
}
